import * as React from 'react';
import { Recipe as RecipeRenderer } from './Recipe';
import { Workout as WorkoutRenderer } from './Workout';

export type RenderPoolItemsAdditionalProps = {
	weight?: number;
};

export function renderPoolItemsForType(
	type: 'workout' | 'recipe',
	items: any[],
	custom: RenderPoolItemsAdditionalProps = {}
) {
	switch (type) {
		case 'workout':
			return <WorkoutRenderer type={type} items={items} custom={custom} />;
		case 'recipe':
			return <RecipeRenderer type={type} items={items} custom={custom} />;
		default:
			return null;
	}
}
